<script setup>
import BaseSettingsHeader from 'dashboard/routes/dashboard/settings/components/BaseSettingsHeader.vue';
import PageContentLayout from './PageContentLayout.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  searchPlaceholder: {
    type: String,
    default: '',
  },
});

const searchQuery = defineModel('searchQuery', {
  type: String,
  default: '',
});
</script>

<template>
  <PageContentLayout class="px-6 pb-8 pt-4">
    <BaseSettingsHeader
      v-model:search-query="searchQuery"
      :title="title"
      :description="description"
      :search-placeholder="searchPlaceholder"
    >
      <template v-if="$slots.tabs" #tabs>
        <slot name="tabs" />
      </template>
      <template v-if="$slots.count" #count>
        <slot name="count" />
      </template>
      <template v-if="$slots.actions" #actions>
        <slot name="actions" />
      </template>
    </BaseSettingsHeader>

    <div class="mt-6 min-w-0">
      <slot />
    </div>
  </PageContentLayout>
</template>
